"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var Input_1 = __importDefault(require("../Input"));

var wallet_1 = require("../../../actions/wallet");

var wallets_1 = require("../../../wallets");

var mapStateToProps = function mapStateToProps(state) {
  var walletState = state.WalletReducer;
  return {
    walletTranslations: walletState.get("walletTranslations"),
    LocalWallet: walletState.get("LocalWallet") || wallets_1.HydroWallet
  };
};

var Create = function (_super) {
  __extends(Create, _super);

  function Create(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      mnemonic: "",
      password: "",
      confirmation: "",
      isConfirm: true,
      processing: false,
      errorMsg: null
    };
    return _this;
  }

  Create.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _a = this.state,
        password = _a.password,
        confirmation = _a.confirmation;

    if (password && confirmation && password !== prevState.password || confirmation !== prevState.confirmation) {
      this.setState({
        isConfirm: password === confirmation
      });
    }
  };

  Create.prototype.submit = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, password, confirmation, mnemonic, _b, dispatch, isRecovery, LocalWallet, wallet, wallet, e_1;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _a = this.state, password = _a.password, confirmation = _a.confirmation, mnemonic = _a.mnemonic;
            _b = this.props, dispatch = _b.dispatch, isRecovery = _b.isRecovery, LocalWallet = _b.LocalWallet;
            e.preventDefault();

            if (password !== confirmation) {
              return [2];
            }

            this.setState({
              processing: true
            });
            _c.label = 1;

          case 1:
            _c.trys.push([1, 6,, 7]);

            if (!isRecovery) return [3, 3];
            return [4, LocalWallet.fromMnemonic(mnemonic, password)];

          case 2:
            wallet = _c.sent();
            dispatch(wallet_1.watchWallet(wallet));
            dispatch(wallet_1.setWalletStep(wallet_1.WALLET_STEPS.SELECT));
            return [3, 5];

          case 3:
            return [4, LocalWallet.createRandom()];

          case 4:
            wallet = _c.sent();
            dispatch(wallet_1.cacheWallet(wallet, password));
            dispatch(wallet_1.setWalletStep(wallet_1.WALLET_STEPS.BACKUP));
            _c.label = 5;

          case 5:
            return [3, 7];

          case 6:
            e_1 = _c.sent();
            this.setState({
              processing: false,
              errorMsg: e_1.message
            });
            return [3, 7];

          case 7:
            return [2];
        }
      });
    });
  };

  Create.prototype.render = function () {
    var _this = this;

    var _a = this.state,
        password = _a.password,
        confirmation = _a.confirmation,
        isConfirm = _a.isConfirm,
        processing = _a.processing;
    var walletTranslations = this.props.walletTranslations;
    return React.createElement("form", {
      className: "HydroSDK-form",
      onSubmit: function onSubmit(e) {
        return _this.submit(e);
      }
    }, this.renderRecoveryInput(), React.createElement(Input_1.default, {
      label: walletTranslations.password,
      text: password,
      handleChange: function handleChange(password) {
        return _this.setState({
          password: password
        });
      }
    }), React.createElement(Input_1.default, {
      label: walletTranslations.confirm,
      errorMsg: isConfirm ? "" : walletTranslations.confirmErrorMsg,
      text: confirmation,
      handleChange: function handleChange(confirmation) {
        return _this.setState({
          confirmation: confirmation
        });
      }
    }), React.createElement("div", {
      className: "HydroSDK-desc"
    }, walletTranslations.createDesc), React.createElement("button", {
      className: "HydroSDK-button HydroSDK-submitButton HydroSDK-featureButton",
      type: "submit",
      disabled: processing || !password || password !== confirmation
    }, processing ? React.createElement("i", {
      className: "HydroSDK-fa fa fa-spinner fa-spin"
    }) : null, " ", walletTranslations.next));
  };

  Create.prototype.renderRecoveryInput = function () {
    var _this = this;

    var _a = this.state,
        mnemonic = _a.mnemonic,
        errorMsg = _a.errorMsg;
    var isRecovery = this.props.isRecovery;

    var _handleChange = function handleChange(mnemonic) {
      _this.setState({
        mnemonic: mnemonic,
        errorMsg: null
      });
    };

    if (!isRecovery) {
      return null;
    }

    return React.createElement(Input_1.default, {
      label: "Recovery Phrase (12 words separated by space)",
      type: "text",
      text: mnemonic,
      errorMsg: errorMsg,
      handleChange: function handleChange(mnemonic) {
        return _handleChange(mnemonic);
      }
    });
  };

  return Create;
}(React.PureComponent);

exports.default = react_redux_1.connect(mapStateToProps)(Create);